var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clientsAdd"},[_c('div',{staticClass:"pageContent"},[_c('heading',{attrs:{"type":"h1"}},[_vm._v("Edit User")]),_vm._v(" "),(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('user-form',{attrs:{"user":_vm.user,"submit":_vm.save},on:{"loading":_vm.onLoadingStatus}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-006ace8a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/users-edit.vue
// module id = null
// module chunks = 